import type { AxiosRequestConfig } from 'axios';
import { authInstance } from '@/shared/api/api-instances/auth/api-instance';
import {
  DSLFieldCaps,
  DSLFieldCapsDTO,
  DSLResponse,
  DSLResponseDTO,
  DSLSearchRequest,
} from '@/shared/api/opensearch';
import { ValidateResponse } from '@/shared/api/validate-response';

export class LogsAPI {
  @ValidateResponse(DSLResponseDTO())
  static getSearch(
    logType: string,
    payload: DSLSearchRequest,
    options?: AxiosRequestConfig,
  ) {
    return authInstance.post<DSLResponse>(`/logs/${logType}/search`, payload, {
      ...options,
    });
  }
  @ValidateResponse(DSLFieldCapsDTO)
  static getFieldCaps(logType: string, options?: AxiosRequestConfig) {
    return authInstance.get<DSLFieldCaps>(`/logs/${logType}/field_caps`, {
      params: { fields: '*' },
      ...options,
    });
  }
  static getLogTypes(options?: AxiosRequestConfig) {
    return authInstance.get<{ name: string; description: string }[]>(
      `/logs/audit_log_types`,
      {
        ...options,
      },
    );
  }
}